import React from 'react';
import { withStyles, WithStyles, Theme } from '@material-ui/core/styles';

export interface MotorcycleMenuProps {
    updateState: (link: string) => void;
    links: string[];
    link: string;
}

const classes = (theme: Theme) => ({

    typeList: {
        display: 'flex',
        justifyContent: 'flex-start',
        paddingTop: 24,
        paddingBottom: 21,
        padding: '0 20px',
    },
    navLink: {
        fontSize: '1em',
        color: 'black',
        lineHeight: 1.625,
        margin: 'initial' as "initial",
        paddingRight: '2.5rem'
    },
    menuWrapper: {
        borderBottom: '1px solid #eee',
    },
});

export const MotorcycleMenu: React.FunctionComponent<MotorcycleMenuProps & WithStyles> = (props: MotorcycleMenuProps & WithStyles) => {
    const { navLink, typeList, menuWrapper } = props.classes;
    return (
        <nav className={menuWrapper}>
            <ul className={typeList}>
                {props.links.map(
                    (link: string, idx: number) => {
                        const selected = link === props.link ? 'selected' : '';
                        return (
                            <li key={idx} onClick={props.updateState.bind(null, link)}
                                className={`ktm-underlined text clickable ${selected} ${navLink}`}>
                                {link}
                            </li>
                        )
                    }
                )}
            </ul>
        </nav>
    );
}

export default withStyles(classes)(MotorcycleMenu);
